<!--<div class="btn-content">
  <a [routerLink]="['/users/manage']" class="btn btn-success">Add New</a>
</div>-->
<div class="content">
  <div class="page-title">
    <h1>Web User Management</h1>

    <div class="add" (click)="add()">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </div>
  </div>

  <div class="card">
    <form class="card-title" (submit)="rebind()">
      <h3><i class="fa fa-search" aria-hidden="true"></i> Search Filters</h3>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Companies</label>
            <app-company-picker [accountId]="filter.company_Id" [_placeholder]="'All'" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Locations</label>
            <app-location-picker [locationId]="filter.location_Id" [companyId]="filter.company_Id" [_placeholder]="'All'" (onLocationSet)="onLocationChange($event)"></app-location-picker>
          </div>
        </div>

        <div class="col-md-3 col-sm-6">
          <label>Name</label>
          <input type="text" class="form-control" name="name" [(ngModel)]="filter.name" />
        </div>

        <div class="col-md-3 col-sm-6">
          <label>Email</label>
          <input type="text" class="form-control" name="email" [(ngModel)]="filter.email" />
        </div>


      </div>


      <div class="row">
        <div class="col-md-12">
          <input type="submit" class="btn btn-primary" value="Refresh" />
          <button (click)="resetFilters()" value="Reset" class="btn reset-data">Reset</button>
          <!--<input type="button" value="Export" class="pull-right btn btn-primary" (click)="generateExcel()" />-->
        </div>
      </div>

    </form>
  </div>

  <app-loading-icon *ngIf="loading"></app-loading-icon>


  <ngx-datatable class="material" [rows]="rows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" *ngIf="!loading"
                 [rowHeight]="'auto'" [limit]="10">

    <ngx-datatable-column name="Firstname" prop="firstname">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Lastname" prop="lastname">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Email" prop="email">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="User Type" prop="userType">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Company Name" prop="company_Name">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Location Name" prop="location_Name">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Option">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <a [routerLink]="['/users/manage', row.id]">Edit</a>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>

</div>
